import {SelectOptions} from '@/types/types'

export const colorsOrb = [
  '',
  'Blue',
  'Green',
  'Red',
  'Objects',
  'Orb-R',
  'Orb-R map',
]
export const colorsOrbOfLevel = ['#00E1FF', '#00FF04', '#FF0000', '#DB00FF']

export const colors = {
  brown: '#0F0A00',
  gray: '#73716D',
  lightBrown: '#FFD7AE',
  orange: '#FF9326',
  yellow: '#FFF172',
  white: '#FFFDF0',
  brown2: '#372819',
  alert: '#FF0000',
  green: '#33FF00',
}

export const colorsHex = {
  owned: '#33FF0050',
  otherUser: '#FF000080',
  notOwner: '#FFFFFF40',
  click: '#0F0A00E5',
  hover: '#FFFDF04D',
}

export const colorsButtons = {
  approve: '#00FF0480',
  decline: '#FF000026',
  edit: 'linear-gradient(180deg, #46128F 0%, #281A3C 100%)',
}

export const colorsParameters: {[key: string]: string} = {
  parameter1: '#33FF00',
  parameter2: '#FDF300',
  parameter3: '#FF3D00',
  parameter4: '#DB00FF',
  parameter5: '#00FFE0',
}

export const LANGUAGES: SelectOptions[] = [
  {value: 'en', label: 'English (EN)'},
  {value: 'ru', label: 'Russian (RU)'},
  {value: 'es', label: 'Spanish (ES)'},
  {value: 'it', label: 'Italian (IT)'},
  {value: 'pt', label: 'Portuguese (PT)'},
]

export const IS_ONE_GM_VISIBLE = false
